// extracted by mini-css-extract-plugin
export default {"cellLabel":"ProductCell_cellLabel__Hj8Yk"};